import {
  LayoutDashboard,
  Fuel,
  GitBranch,
  Users,
  User,
  ArrowLeftRight,
  Gauge,
  Car,
  type LucideIcon,
} from 'lucide-react';
import { BASE_URL } from '@/config';

export interface NavItem {
  title: string;
  path: string;
  icon: LucideIcon;
  children?: NavItem[];
}

export const sidebarConfig: NavItem[] = [
  { title: 'Dashboard', path: BASE_URL, icon: LayoutDashboard },
  {
    title: 'Citernes',
    path: `${BASE_URL}citernes`,
    icon: Fuel,
    children: [
      { title: 'Citernes', path: `${BASE_URL}citernes`, icon: Fuel },
      { title: 'Mouvements', path: `${BASE_URL}movements`, icon: ArrowLeftRight },
      { title: 'Jauges', path: `${BASE_URL}jauges`, icon: Gauge },
    ],
  },
  { title: 'Engins', path: `${BASE_URL}engins`, icon: Car },
  { title: 'Chantiers', path: `${BASE_URL}chantiers`, icon: GitBranch },
  { title: 'Tiers', path: `${BASE_URL}tiers`, icon: User },
  { title: 'Utilisateurs', path: `${BASE_URL}users`, icon: Users },
];
